import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Switch } from '@/components/ui/switch';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { ExternalLink, AlertCircle } from 'lucide-react';
import { useTestClock } from '@/contexts/TestClockContext';

export const CheckoutSettings = () => {
  const { openCheckoutInNewTab, setOpenCheckoutInNewTab } = useTestClock();

  return (
    <Card className="app-tile app-tile-hover">
      <CardHeader>
        <div className="flex items-center gap-2">
          <div className="app-icon-box">
            <ExternalLink className="h-5 w-5" />
          </div>
          <div>
            <CardTitle className="app-section-title">Checkout Behavior</CardTitle>
            <CardDescription>
              Control how Stripe checkout sessions are opened
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="app-info-box flex items-center justify-between">
          <div className="flex-1">
            <h3 className="text-sm font-semibold mb-1">Open Checkout in New Tab</h3>
            <p className="text-xs text-muted-foreground">
              {openCheckoutInNewTab 
                ? "Checkout sessions will open in a new tab" 
                : "Checkout sessions will redirect in the same tab"}
            </p>
          </div>
          <Switch
            checked={openCheckoutInNewTab}
            onCheckedChange={setOpenCheckoutInNewTab}
          />
        </div>

        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Global Setting</AlertTitle>
          <AlertDescription>
            This setting affects all Stripe checkout redirects including subscriptions and top-ups.
            When enabled, the current tab stays open while checkout opens in a new tab.
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};
